import {
  getPropertyRef,
  getUserRef,
  getWidgetCollectionRef,
  getWidgetRef,
} from "../../../firebase/collectionReferences";
import { getDocs, setDoc, updateDoc } from "firebase/firestore";

export async function getWidgetsByPropertyId(propertyId) {
  if (propertyId) {
    const propertyRef = getPropertyRef(propertyId);
    const widgetRef = getWidgetCollectionRef(propertyRef);

    return (await getDocs(widgetRef)).docs
      .map((row) => ({ id: row.id, ...row.data() }))
      .pop();
  }
}

export async function updateWidget(propertyId, widgetId, data) {
  const propertyRef = getPropertyRef(propertyId);
  const widgetRef = getWidgetRef(propertyRef, widgetId);
  await setDoc(widgetRef, data, { merge: true });
}

export async function handleActiveVistorSound(userId, data) {
  const userRef = getUserRef(userId);
  await updateDoc(
    userRef,
    {
      disableActiveVisitorSound: data?.disableActiveVisitorSound,
    },
    { merge: true }
  );

  return data;
}

export async function handleSounds(userId, data) {
  const userRef = getUserRef(userId);
  await updateDoc(
    userRef,
    {
      sounds: data,
    },
    { merge: true }
  );

  return data;
}
